import { getToken, setToken, removeToken } from '@/utils/auth'
import request from '@/utils/request'

const state = {
  token: getToken() || '',
  name: '',
  menus: []
}

const mutations = {
  SET_TOKEN(state, token) { state.token = token },
  SET_NAME(state, name) { state.name = name },
  SET_MENUS(state, menus) { state.menus = menus }
}

const actions = {
  login({ commit }, form) {
    return request({ url: '/adminapi/auth/login', method: 'post', data: form }).then(res => {
      commit('SET_TOKEN', res.data.token)
      setToken(res.data.token)
      return res
    })
  },
  getInfo({ commit }) {
    return request({ url: '/adminapi/auth/info', method: 'get' }).then(res => {
      commit('SET_NAME', res.data.nickname || res.data.username)
      commit('SET_MENUS', res.data.menus || [])
      return res.data
    })
  },
  logout({ commit }) {
    return request({ url: '/adminapi/auth/logout', method: 'post' }).finally(() => {
      commit('SET_TOKEN', '')
      commit('SET_MENUS', [])
      removeToken()
    })
  },
  resetToken({ commit }) {
    commit('SET_TOKEN', '')
    removeToken()
  }
}

export default { namespaced: true, state, mutations, actions }
